import axios from 'axios';
import Api, { url } from '../api'
import { AuthControllerRoute } from './routes/AuthControllerRoute'
import { Alert } from '../../util/Alert';
import { setGlobalLoader } from '../../context/LoaderContext';
import { toast } from 'react-toastify';
import { deleteCookie, getCookie, setCookie } from '../../util/Cookie';
import { GetClientApi } from './ClientsController';

const api = new Api(url, getCookie("access_token"))

export const AuthLoginApi = ({ login, senha }, callBack) => {
    const request = { login, senha };
    setGlobalLoader(true);
    axios.post(url + AuthControllerRoute.login, request, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch((err) => {
            if (err.response?.status === 401 && err.response?.data?.mensagem !== "Login ou senha inválidos") {
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = this.loginPage;
                return;
            }
            Alert(err.response?.data.mensagem, "", false);
        })
        .finally(() => {
            setGlobalLoader(false);
        });
}

export const AuthMe = (callBack) => {
    axios.get(url + AuthControllerRoute.me, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch((err) => {

        })
        .finally(() => {
            setGlobalLoader(false);
        });
}

export const AuthRegisterApi = (
    {
        login,
        senha,
        confirmacaoSenha,
        cpf,
        nomeCompleto,
        dataNascimento,
        email,
        telefone,
        tipoUsuario,
        matricula,
        cidade,
        uf
    }, callBack) => {
    const request = {
        login,
        senha,
        confirmacaoSenha,
        cpf,
        nomeCompleto,
        dataNascimento,
        email,
        telefone,
        tipoUsuario,
        matricula,
        cidade,
        uf
    };
    api.post(AuthControllerRoute.register,
        request,
        response => {
            GetClientApi(response.data.usuario.clienteId, (client) => {
                setCookie("client_data", JSON.stringify(client), 1);
                setCookie("user_data", JSON.stringify(response.usuario), 1);
                setCookie("access_token", response.token, 1);
                callBack(false, '');
            }, response.token)
        },
        (isRequiredToken, solicitationNumber, token) =>
            callBack(isRequiredToken, solicitationNumber, token),
    );
}

export const UpdatePasswordApi = (request, callBack) => {
    setGlobalLoader(true);
    axios.post(url + '/api/Auth/alterar-senha', request, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch((err) => {
            toast.error("Houve um erro na solicitação")
        })
        .finally(() => {
            setGlobalLoader(false);
        });
}